export const SESSION_STORAGE = 'SessionStorage'
export const SUCCESS = 200

export const ADD = 1;
export const EDIT = 2;
export const DELETE = 3;